var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import CustomBreadcrumbs from '@spa/shared/components/CustomBreadcrumbs';
import { getHomeUrl } from '@spa/shared/utils/stringAndUrlUtils';
import { translationFromLocale } from '@spa/shared/utils/transformers';
var BreadcrumbsContainer = function BreadcrumbsContainer(_ref) {
  var _neighborhood$metadat, _city$metadata, _city$configuration, _city$configuration2, _offerAggregate$accom;
  var offerAggregate = _ref.offerAggregate,
    city = _ref.city,
    neighborhood = _ref.neighborhood,
    currentLocale = _ref.currentLocale;
  var homeUrl = getHomeUrl();
  var baseAccommodationUrl = "".concat(homeUrl, "accommodation");
  var neighborhoodName = neighborhood !== null && neighborhood !== void 0 && (_neighborhood$metadat = neighborhood.metadata) !== null && _neighborhood$metadat !== void 0 && _neighborhood$metadat.name_translations ? translationFromLocale(neighborhood.metadata.name_translations, currentLocale) : '';
  var cityName = city !== null && city !== void 0 && (_city$metadata = city.metadata) !== null && _city$metadata !== void 0 && _city$metadata.name_translations ? translationFromLocale(city.metadata.name_translations, currentLocale) : '';
  var breadcrumbsProps = {
    homeUrl: homeUrl,
    cityName: cityName,
    cityUrl: city !== null && city !== void 0 && (_city$configuration = city.configuration) !== null && _city$configuration !== void 0 && _city$configuration.slug ? "".concat(baseAccommodationUrl, "/").concat(city.configuration.slug) : baseAccommodationUrl,
    neighborhoodName: neighborhoodName,
    neighborhoodUrl: neighborhood !== null && neighborhood !== void 0 && neighborhood.slug && city !== null && city !== void 0 && (_city$configuration2 = city.configuration) !== null && _city$configuration2 !== void 0 && _city$configuration2.slug ? "".concat(baseAccommodationUrl, "/").concat(city.configuration.slug, "/neighbourhood/").concat(neighborhood.slug) : null,
    pageTitle: offerAggregate === null || offerAggregate === void 0 ? void 0 : (_offerAggregate$accom = offerAggregate.accommodation_offer) === null || _offerAggregate$accom === void 0 ? void 0 : _offerAggregate$accom.title
  };
  return __jsx(CustomBreadcrumbs, breadcrumbsProps);
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var offerAggregate = _ref2.offer.offerAggregate;
  var _ref3 = offerAggregate || {},
    _ref3$globalization_a = _ref3.globalization_aggregate,
    city = _ref3$globalization_a.city,
    _ref3$globalization_a2 = _ref3$globalization_a.locale,
    currentLocale = _ref3$globalization_a2 === void 0 ? 'en' : _ref3$globalization_a2,
    neighborhood = _ref3.property_aggregate.neighborhood;
  return {
    offerAggregate: offerAggregate,
    city: city,
    neighborhood: neighborhood,
    currentLocale: currentLocale
  };
};
export default connect(mapStateToProps)(BreadcrumbsContainer);